(function() {
    'use strict';
    angular.module('wbDashboard').factory('Display', ['$state', '$timeout', 'Message', 'Session', '$uibModal', '$filter', 'Track', function ($state, $timeout, Message, Session, $uibModal, $filter, Track) {

        var display = {},
            displayData = {
                view: null,
                menu: false,
            };

        display.getView = function() {
            return displayData.view;
        };
        display.setViewToMain = function() {
            displayData.view = 'main';
            return displayData.view;
        };
        display.setViewToMaintenanceMode = function() {
            displayData.view = 'maintenance-mode';
            return displayData.view;
        };

        display.getMenu = function() {
            return displayData.menu;
        };

        display.setMenu = function(value) {
            displayData.menu = value;
            return displayData.menu;
        };

        display.setNotification = function(notification) {
            if (notification && displayData.view === 'main') {
                displayData.view = "notification-modal";
            }
        };

        display.initView = function(overview) {
            displayData.view = null;

            if (overview) {
                var flags = {};

                displayData.view = "main";

                try {
                    flags = overview.user.flags;
                } catch (e) { /*nothing*/ }

                //need double equal sign due to unknown type from server
                if (flags.signup_agreement_signed !== 1) {
                    displayData.view = "agreement";
                } else if (flags.need_documents_toggled === 1) {
                   displayData.view = "document_request";
                } else if (Session.get('welcomeTour')) {
                    displayData.view = "welcome";
                }


                if (displayData.view === 'main') {

                    //messaging about pending bank accounts
                    //could be updated to (bank_accounts.pending) if we made that available here
                    if (overview.pending_account_for_bank) {
                        if (['AWAITING_VERIFICATION', 'waiting_for_verification'].includes(overview.pending_account_for_bank.bank_status)) {
                            $state.go("base.profile.banks");
                        } else if (!$state.current.name.includes("base.profile.banks")) {
                            $timeout(function () {
                                Message.add({
                                    key: 'bankPending',
                                    text: 'Your bank account is pending <a ui-sref="base.profile.banks">click here for more information</a> or go to your Linked Bank page',
                                    type: 'warning',
                                    timeout: false
                                });
                            }, 2000);
                        }
                    }
                }

                if (overview.user.is_closed) {
                    display.closedAccountMessage(overview.user.closed_at);
                }

            }

        };

        display.closedAccountMessage = function(date) {
            var closed_at = null;
            var message;
            if (date) {
                closed_at = date.split(/[ T]/)[0];
                message = 'You requested to leave Axos Invest Managed Portfolios on ' + $filter('date')(closed_at, 'MM/dd/yyyy');
            } else {
                message = 'You requested to leave Axos Invest Managed Portfolios';
            }
            Message.add({
                key: 'closed',
                text: message,
                type: 'danger',
                timeout: false,
                dismissible: true
            });
        };

        return display;
    }]);
})();
